<template>
    <div v-if="mission">
        <h6 class="mb-2">Convoi</h6>
        <template v-if="Array.isArray(mission.balises) && mission.balises.length">
            <div class="row g-2">
                <div v-for="balise in mission.balises" :key="balise.id" class="col-auto">
                    <VehicleNameDisplay :balise="balise" class="bg-primary bg-opacity-10 rounded px-2 my-1" />
                </div>
            </div>
        </template>
        <template v-else>
            <span class="text-muted">Aucun véhicule dans le convoi.</span>
        </template>
    </div>
</template>

<script>
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'

export default {
    name: 'ConvoyListCompact',
    props: {
        mission: { type: Object, required: true }
    },
    components: { VehicleNameDisplay }
}
</script>
